import { MeetingExceptions } from './meeting_exceptions'

export const SingleHost = ({ doubleBookingRuleMembership, variant = 'legacy' }) => (
  <MeetingExceptions
    doubleBookingRuleMembership={doubleBookingRuleMembership}
    doubleBookingRuleMembershipIndex={0}
    variant={variant}
  />
)
